import { ReactNode, createContext, useContext, useMemo } from 'react';

import { SensorType } from '@/api/device';

export type SensorPriorityContextType = {
    prioritySensor: SensorType | null;
};

const defaultSensorPriorityContextData: SensorPriorityContextType = {
    prioritySensor: null,
} as const;

const SensorPriorityContext = createContext(defaultSensorPriorityContextData);

const SensorPriorityContextProvider = ({ children, sensor }: { children: ReactNode; sensor?: SensorType | null }) => {
    const contextValue = useMemo(() => ({ prioritySensor: sensor ?? null }), [sensor]);

    return <SensorPriorityContext.Provider value={contextValue}>{children}</SensorPriorityContext.Provider>;
};

const useSensorPriorityContext = () => useContext(SensorPriorityContext);

export { SensorPriorityContextProvider, useSensorPriorityContext };
